import { render } from "./LayerInfo.vue?vue&type=template&id=35e1bfbf"
import script from "./LayerInfo.vue?vue&type=script&lang=js"
export * from "./LayerInfo.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__